import * as actionTypes from './actiontypes';
import { PAGE_LOADING, PAGE_LOADED } from '../page_details/actiontypes';
import * as API from './api';
import { log, showMessage } from '../../config/utils';

export const getAllVariables = () => {
    return dispatch => {
        dispatch({
            type: actionTypes.VARIABLES_LOADING,
        });
        API.getAllVariables({}, (error, response) => {
            log('get all variables response:', response);
            if (!error && response && response.data) {
                dispatch({
                    type: actionTypes.VARIABLES_LOADED,
                    payload: response.data,
                });
            } else {
                dispatch({
                    type: actionTypes.VARIABLES_LOAD_ERROR,
                });
            }
        });
    };
};

export const createVariable = (data, callback) => {
    return dispatch => {
        dispatch({
            type: actionTypes.VARIABLE_CREATING,
        });

        API.createVariable(data, (error, response) => {
            log('add variable response:', response);
            dispatch({
                type: actionTypes.VARIABLE_CREATE_COMPLETE,
            });
            if (!error && response && response.data) {
                dispatch({
                    type: actionTypes.VARIABLE_CREATED,
                    payload: response.data,
                });
                if (callback) callback();
                showMessage('success', response.message ? response.message : 'variable has been successfully created.');
            }
        });
    };
};

export const updateVariable = (data, callback) => {
    return dispatch => {
        dispatch({
            type: actionTypes.VARIABLE_UPDATING,
        });

        API.updateVariable(data, (error, response) => {
            log('update variable response:', response);
            dispatch({
                type: actionTypes.VARIABLE_UPDATE_COMPLETE,
            });
            if (!error && response && response.data) {
                dispatch({
                    type: actionTypes.VARIABLE_UPDATED,
                    payload: response.data,
                });
                if (callback) callback();
                showMessage('success', response.message ? response.message : 'variable has been successfully updated.');
            }
        });
    };
};

export const deleteVariable = data => {
    return dispatch => {
        dispatch({
            type: PAGE_LOADING,
            payload: "variable deleting"
        });
        API.deleteVariable(data, (error, response) => {
            log('delete Variable response:', response);
            dispatch({
                type: PAGE_LOADED,
            });
            if (!error && response && response.data) {
                dispatch({
                    type: actionTypes.VARIABLE_DELETED,
                    payload: response.data
                });
                showMessage('success', response && response.message ? response.message : 'variable has been successfully deleted.');
            }
        });
    };
};

export const getAllActions = () => {
    return dispatch => {
        dispatch({
            type: actionTypes.ACTIONS_LOADING,
        });
        API.getAllActions({}, (error, response) => {
            log('get all actions response:', response);
            if (!error && response && response.data) {
                dispatch({
                    type: actionTypes.ACTIONS_LOADED,
                    payload: response.data,
                });
            } else {
                dispatch({
                    type: actionTypes.ACTIONS_LOAD_ERROR,
                });
            }
        });
    };
};

export const createAction = (data, callback) => {
    return dispatch => {
        dispatch({
            type: PAGE_LOADING,
            payload: "New Action creating"
        });
        API.createAction(data, (error, response) => {
            log('add action response:', response);
            dispatch({
                type: PAGE_LOADED,
            });
            if (!error && response && response.data) {
                dispatch({
                    type: actionTypes.ACTION_CREATED,
                    payload: response.data,
                });
                if (callback) callback();
                showMessage('success', response && response.message ? response.message : 'action has been successfully deleted.');
            }
        });
    };
};

export const updateAction = (data, callback) => {
    return dispatch => {
        dispatch({
            type: PAGE_LOADING,
            payload: "action updating"
        });
        API.updateAction(data, (error, response) => {
            log('update action response:', response);
            dispatch({
                type: PAGE_LOADED,
            });
            if (!error && response && response.data) {
                dispatch({
                    type: actionTypes.ACTION_UPDATED,
                    payload: response.data,
                });
                if (callback) callback();
                showMessage('success', response && response.message ? response.message : 'action has been successfully updated.');
            }
        });
    };
};

export const deleteAction = data => {
    return dispatch => {
        dispatch({
            type: PAGE_LOADING,
            payload: "action deleting"
        });
        API.deleteAction(data, (error, response) => {
            log('delete action response:', response);
            dispatch({
                type: PAGE_LOADED,
            });
            if (!error && response && response.data) {
                dispatch({
                    type: actionTypes.ACTION_DELETED,
                    payload: response.data
                });
                showMessage('success', response && response.message ? response.message : 'action has been successfully deleted.');
            }
        });
    };
};






// WEBPACK FOOTER //
// ./src/data/redux/botparams_details/actions.js